import $ from 'sbf-design-system/js/jquery';

const $accordions = $('.sbf-accordion');
const $expandAllButton = $('#js-accordion-expand');
const $collapseAllButton = $('#js-accordion-collapse');

$expandAllButton.on('click', () => {
  $accordions.each(function () { this.open = true; });
  $expandAllButton.prop('disabled', true);
  $collapseAllButton.prop('disabled', false);
});

$collapseAllButton.on('click', () => {
  $accordions.each(function () { this.open = false; });
  $expandAllButton.prop('disabled', false);
  $collapseAllButton.prop('disabled', true);
});

const updateButtonState = () => {
  $expandAllButton.prop('disabled', $accordions.filter('[open]').length === $accordions.length);
  $collapseAllButton.prop('disabled', $accordions.filter('[open]').length === 0);
}

$accordions.on('toggle', updateButtonState);